import { Button } from "react-bootstrap";
import { RiEdit2Fill } from "react-icons/ri";
import { BsTrash } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import { Tooltip } from "antd";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";

export const refundInitFilterInput = {
  searchName: "",
  transactionStartDate: null,
  transactionEndDate: null,
  page: 1,
  pageSize: 10,
  sortingField: null,
  sortingOrder: null,
};

export const failedRedeemInitFilterInput = {
  searchName: "",
  category: 0,
  paymentType: "semua",
  tenorType: "semua",
  tenor: 0,
  failedRedeemStartDate: null,
  failedRedeemEndDate: null,
  page: 1,
  pageSize: 10,
  status: "semua",
  sortingField: null,
  sortingOrder: null,
};

export const pawnTransactionInitFilterInput = {
  searchName: "",
  category: 0,
  paymentType: "semua",
  tenorType: "semua",
  tenor: 0,
  outlets: [],
  transactionStartDate: null,
  transactionEndDate: null,
  extensionStartDate: null,
  extensionEndDate: null,
  page: 1,
  pageSize: 10,
  transactionStatus: "semua",
  sortingField: null,
  sortingOrder: null,
};

export const addRefundInitData = {
  gadaiCode: "",
  reward: "",
  remainingMoney: "",
  description: "",
  bankName: "",
  accountNumber: "",
  accountName: "",
  transferProof: "",
  approvalProof: "",
};

export const changeStatusInitData = {
  status: "",
  sellPrice: "",
  offeringLink: "",
  document: "",
  otherPrice: "",
  description: "",
};

export const processBiddingInitData = {
  destination: "",
  offeringLink: "",
};

export const failedReedemStatusList = [
  {
    text: "Semua",
    count: 0,
    value: "semua",
    active: true,
  },
  {
    text: "Gagal Tebus",
    count: 0,
    value: "payment-failed",
    active: false,
  },
  {
    text: "Proses Penawaran",
    count: 0,
    value: "auction-progress",
    active: false,
  },
  {
    text: "Dijual di E-Boutique",
    count: 0,
    value: "sold-eboutique",
    active: false,
  },
  {
    text: "Terjual ke Mitra",
    count: 0,
    value: "sold-mitra",
    active: false,
  },
];

export const pawnTransactionStatusList = [
  {
    text: "Semua",
    count: 0,
    value: "semua",
    active: true,
  },
  {
    text: "Dalam Masa Pinjaman",
    count: 0,
    value: "ongoing",
    active: false,
  },
  {
    text: "Lunas",
    count: 0,
    value: "done",
    active: false,
  },
  {
    text: "Melewati Tenor",
    count: 0,
    value: "payment-late",
    active: false,
  },
  {
    text: "Perpanjangan",
    count: 0,
    value: "extended",
    active: false,
  },
  {
    text: "Gagal Tebus",
    count: 0,
    value: "payment-failed",
    active: false,
  },
  {
    text: "Proses Lelang",
    count: 0,
    value: "auction-progress",
    active: false,
  },
  {
    text: "Terjual",
    count: 0,
    value: "auction-done",
    active: false,
  },
];

export const pawnReportColumns = [
  {
    dataIndex: "dateTime",
    key: "dateTime",
    backend_key: "gadai_at",
    title: "Tanggal & Waktu",
    sorter: true,
    width: "100px",
  },
  {
    dataIndex: "gadaiID",
    key: "gadaiID",
    title: "ID Transaksi",
  },
  {
    dataIndex: "pawnNumber",
    key: "pawnNumber",
    title: "No. Surat Bukti Gadai",
    width: "100px",
  },
  {
    dataIndex: "receiptNumber",
    key: "receiptNumber",
    title: "No. Kwitansi",
    width: "220px",
  },
  {
    dataIndex: "gadaiCode",
    key: "gadaiCode",
    title: "Kode Gadai",
    width: "100px",
  },
  {
    dataIndex: "promoUsed",
    key: "promoUsed",
    title: "Promo Digunakan",
    render: (_, record) => {
      return record.promoUsed.map((item, index) => <p className="m-0" key={index}>{item}</p>);
    },
  },
  {
    dataIndex: "customerName",
    key: "customerName",
    backend_key: "ktp_name",
    title: "Nama Nasabah",
    sorter: true,
    width: "200px",
  },
  {
    dataIndex: "category",
    key: "category",
    title: "Kategori Produk",
    width: "100px",
  },
  {
    dataIndex: "paymentType",
    key: "paymentType",
    title: "Jenis Pembayaran",
    width: "100px",
  },
  {
    dataIndex: "tenorType",
    key: "tenorType",
    title: "Jenis Tenor",
    width: "100px",
  },
  {
    dataIndex: "tenor",
    key: "tenor",
    title: "Tenor",
    width: "100px",
  },
  {
    dataIndex: "valuationValue",
    key: "valuationValue",
    title: "Nilai Valuasi",
    width: "130px",
  },
  {
    dataIndex: "amountReceived",
    key: "amountReceived",
    title: "Jumlah Diterima",
    width: "130px",
  },
  {
    dataIndex: "initialCapitalLease",
    key: "initialCapitalLease",
    title: "Sewa Modal Awal",
    width: "130px",
  },
  {
    dataIndex: "promoCapitalLease",
    key: "promoCapitalLease",
    title: "Sewa Modal Promo",
    width: "130px",
  },
  {
    dataIndex: "initialAdminFee",
    key: "initialAdminFee",
    title: "Administrasi Awal",
    width: "130px",
  },
  {
    dataIndex: "promoAdminFee",
    key: "promoAdminFee",
    title: "Administrasi Promo",
    width: "130px",
  },
  {
    dataIndex: "initialStoreAndInsurance",
    key: "initialStoreAndInsurance",
    title: "Simpan & Asuransi Awal",
    width: "130px",
  },
  {
    dataIndex: "promoStoreAndInsurance",
    key: "promoStoreAndInsurance",
    title: "Simpan & Asuransi Promo",
    width: "130px",
  },
  {
    dataIndex: "transferAmount",
    key: "transferAmount",
    title: "Biaya Transfer",
    width: "130px",
  },
  {
    dataIndex: "initialCapitalLeaseExtension",
    key: "initialCapitalLeaseExtension",
    title: "Sewa Modal Perpanjangan Awal",
    width: "130px",
  },
  {
    dataIndex: "promoCapitalLeaseExtension",
    key: "promoCapitalLeaseExtension",
    title: "Sewa Modal Perpanjangan Promo",
    width: "130px",
  },
  {
    dataIndex: "initialAdminFeeExtension",
    key: "initialAdminFeeExtension",
    title: "Administrasi Perpanjangan Awal",
    width: "130px",
  },
  {
    dataIndex: "promoAdminFeeExtension",
    key: "promoAdminFeeExtension",
    title: "Administrasi Perpanjangan Promo",
    width: "130px",
  },
  {
    dataIndex: "initialStoreAndInsuranceExtension",
    key: "initialStoreAndInsuranceExtension",
    title: "Simpan & Asuransi Perpanjangan Awal",
    width: "130px",
  },
  {
    dataIndex: "promoStoreAndInsuranceExtension",
    key: "promoStoreAndInsuranceExtension",
    title: "Simpan & Asuransi Perpanjangan Promo",
    width: "130px",
  },
  {
    dataIndex: "initialRevaluationValue",
    key: "initialRevaluationValue",
    title: "Nilai Revaluasi Awal",
    width: "130px",
  },
  {
    dataIndex: "promoRevaluationValue",
    key: "promoRevaluationValue",
    title: "Nilai Revaluasi Promo",
    width: "130px",
  },
  {
    dataIndex: "lateFee",
    key: "lateFee",
    title: "Denda Keterlambatan",
    width: "130px",
  },
  {
    dataIndex: "lateStorage",
    key: "lateStorage",
    title: "Penyimpanan Keterlambatan",
    width: "130px",
  },
  {
    dataIndex: "deliveryFee",
    key: "deliveryFee",
    title: "Ongkos Kirim",
    width: "130px",
  },
  {
    dataIndex: "auctionService",
    key: "auctionService",
    title: "Jasa Lelang",
    width: "130px",
  },
  {
    dataIndex: "refund",
    key: "refund",
    title: "Pengembalian Dana",
    width: "130px",
  },
  {
    dataIndex: "excessAuction",
    key: "excessAuction",
    title: "Kelebihan Lelang",
    width: "130px",
  },
  {
    dataIndex: "totalPayment",
    key: "totalPayment",
    title: "Total Pembayaran",
    width: "130px",
  },
  {
    dataIndex: "itemAuctionPrice",
    key: "itemAuctionPrice",
    title: "Harga Lelang Barang",
    width: "130px",
  },
  {
    dataIndex: "status",
    key: "status",
    title: "Status",
    width: "130px",
  },
  // {
  //   dataIndex: "action",
  //   key: "action",
  //   title: "Aksi",
  //   render: (_, record) => (
  //     <div style={{ textAlign: "center", display: "grid" }}>
  //       <CanAccess
  //         role={AuthorizationList.view_gadai}
  //         yes={
  //           <NavLink to={`/report/pawn/${record.gadaiID}`}>
  //             <Button variant="primary" className="btn-action btn-detail">
  //               Detail
  //             </Button>
  //           </NavLink>
  //         }
  //       />
  //     </div>
  //   ),
  // },
];

export const renderRefundColumns = (
  handleEditButtonClick = null,
  handleDeleteButtonClick = null,
  renderColumn = true
) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      backend_key: "date_time",
      title: "Tanggal & Waktu",
      sorter: true,
      width: 70,
    },
    {
      dataIndex: "pawnNumber",
      key: "pawnNumber",
      title: "No. Surat Bukti Gadai",
      width: 80,
    },
    {
      dataIndex: "receiptNumber",
      key: "receiptNumber",
      title: "No. Kwitansi",
      width: 100,
    },
    {
      dataIndex: "gadaiCode",
      key: "gadaiCode",
      backend_key: "gadai_proof",
      title: "Kode Gadai",
      width: 100,
      sorter: true,
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      backend_key: "customer_name",
      title: "Nama Nasabah",
      width: "10%",
      sorter: true,
    },
    {
      dataIndex: "reward",
      key: "reward",
      title: "Reward",
      width: 100,
    },
    {
      dataIndex: "remainingMoney",
      key: "remainingMoney",
      title: "Sisa Uang Lelang",
      width: 100,
    },
    {
      dataIndex: "accountName",
      key: "accountName",
      backend_key: "bank_account_name",
      title: "Nama Rekening",
      width: "10%",
      sorter: true,
    },
    {
      dataIndex: "bankOrAccountNumber",
      key: "bankOrAccountNumber",
      title: "Bank/No. Rekening",
      width: "12%",
    },
    {
      dataIndex: "description",
      key: "description",
      title: "Keterangan",
      width: "12%",
    },
    ...(renderColumn
      ? [
          {
            dataIndex: "transferProof",
            key: "transferProof",
            title: "Bukti Transfer",
            width: "7%",
          },
          {
            dataIndex: "approvalProof",
            key: "approvalProof",
            title: "Bukti Persetujuan",
            width: "7%",
          },
          {
            dataIndex: "action",
            key: "action",
            title: "Aksi",
            width: "5%",
            render: (_, record) => (
              <div className="d-flex" style={{ gap: "10px" }}>
                <Button
                  className="btn-icon icon-edit"
                  onClick={() => handleEditButtonClick(record)}
                >
                  <RiEdit2Fill size={24} />
                </Button>
                <Button
                  className="btn-icon icon-delete"
                  onClick={() =>
                    handleDeleteButtonClick(record.gadaiID, record.gadaiCode)
                  }
                >
                  <BsTrash size={24} />
                </Button>
              </div>
            ),
          },
        ]
      : []),
  ];
};

export const renderFailedRedeemColumns = (
  handleProcessBiddingButtonClick = null,
  handleChangeStatusButtonClick = null,
  renderColumn = true
) => {
  return [
    {
      dataIndex: "dateTime",
      key: "dateTime",
      title: "Tanggal & Waktu",
      sorter: true,
      width: "7%",
    },
    {
      dataIndex: "pawnNumber",
      key: "pawnNumber",
      title: "No. Surat Bukti Gadai",
    },
    {
      dataIndex: "receiptNumber",
      key: "receiptNumber",
      title: "No. Kwitansi",
    },
    {
      dataIndex: "customerName",
      key: "customerName",
      title: "Nama Nasabah",
      sorter: true,
    },
    {
      dataIndex: "category",
      key: "category",
      title: "Kategori Produk",
    },
    {
      dataIndex: "description",
      key: "description",
      title: "Keterangan Barang",
    },
    {
      dataIndex: "location",
      key: "location",
      title: "Lokasi Barang",
    },
    {
      dataIndex: "destination",
      key: "destination",
      title: "Tujuan Barang",
    },
    {
      dataIndex: "offerLink",
      key: "offerLink",
      title: "Link Penawaran",
      ellipsis: renderColumn ? false : true,
      ...(renderColumn && {
        render: (offerLink) => (
          <Tooltip placement="topLeft" title={offerLink?.props?.children}>
            {offerLink}
          </Tooltip>
        ),
      }),
      width: "11%",
    },
    {
      dataIndex: "soldPrice",
      key: "soldPrice",
      title: "Harga Terjual",
      width: "10%",
    },
    {
      dataIndex: "auctionOtherFee",
      key: "auctionOtherFee",
      title: "Biaya Lain-lain",
      width: "10%",
    },
    {
      dataIndex: "keterangan",
      key: "keterangan",
      title: "Keterangan",
      width: "10%",
    },
    ...(renderColumn
      ? [
          {
            dataIndex: "document",
            key: "document",
            title: "Surat Jalan",
          },
        ]
      : []),
    {
      dataIndex: "status",
      key: "status",
      title: "Status",
    },
    ...(renderColumn
      ? [
          {
            dataIndex: "action",
            key: "action",
            title: "Aksi",
            width: "12%",
            render: (_, record) => (
              <div className="d-flex flex-column" style={{ gap: "10px" }}>
                {(record.status.toLowerCase() === "gagal tebus" ||
                  record.status.toLowerCase() === "proses penawaran" ||
                  record.status === "payment-failed" ||
                  record.status === "auction-progress") && (
                  <Button
                    variant="primary"
                    className="btn-action btn-detail"
                    onClick={() =>
                      record.status.toLowerCase() === "gagal tebus" ||
                      record.status === "payment-failed"
                        ? handleProcessBiddingButtonClick(record.failedRedeemID)
                        : handleChangeStatusButtonClick(record.failedRedeemID)
                    }
                  >
                    {record.status.toLowerCase() === "gagal tebus" ||
                    record.status === "payment-failed"
                      ? "Proses Penawaran"
                      : "Ubah Status"}
                  </Button>
                )}
                <CanAccess
                  role={AuthorizationList.view_gadai}
                  yes={
                    <NavLink to={`/report/pawn/${record.gadaiID}`}>
                      <Button
                        variant="outline-secondary"
                        className="btn-action btn-default"
                        style={{ width: "100%", color: "#2C465C" }}
                      >
                        Detail
                      </Button>
                    </NavLink>
                  }
                />
              </div>
            ),
          },
        ]
      : []),
  ];
};
